import type {Auth0ContextInterface} from "@auth0/auth0-react";
import type {Location, NavigateFunction} from "react-router";
import type {AuthManager} from "../AuthManager";
import axios from "axios";
import type {MithraLoginResponse} from "../../services/ApiTypes";
import {environment} from "../../env";
import {B} from "../../build";
import type AuthStore from "../AuthStore";
import type Rollbar from "rollbar";


export function auth0Login(
    authStore: AuthStore,
    auth0Context: Auth0ContextInterface,
    location: Location,
    navigate: NavigateFunction,
    rollbar?: Rollbar,
): void {
    const authManager: AuthManager = authStore.authentication;

    authManager.startLogin('auth0');
    auth0Context.loginWithPopup({
        authorizationParams: {
            organization: B.AUTH0_ORGANIZATION,
        }
    }).then(() => {
        auth0Context.getAccessTokenSilently()
            .then(access_token => {
                return axios.post<MithraLoginResponse>(`${environment.authUrl}/login/auth0/`, {access_token})
                    .then(resp => {
                        (rollbar ?? console).debug('auth0Login: POST login/auth0 succeeded', resp.data?.user?.email);
                        authManager.processMithraLoginSuccess(resp.data, location, navigate, 'auth0', rollbar);
                    })
                    .catch(err => {
                        (rollbar ?? console).error('auth0Login: POST login/auth0: failed', err);
                        authManager.processMithraLoginError(err);
                    })
            })
            .catch(err => {
                (rollbar ?? console).error('auth0Login: getAccessTokenSilently(): failed', err);
                authManager.processMithraLoginError(err)
            })

    }).catch(err => {
        (rollbar ?? console).error('auth0Login: loginWithPopup(): failed', err);
        authManager.processMithraLoginError(err)
    });
}